;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"{{SENTRY_RELEASE}}"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import createSentryConfig from '@/Framework/browser/log/sentry/createSetryConfig';

createSentryConfig({ entry: 'finsight' });
